import { useState, useMemo } from 'react'
import PropTypes from 'prop-types'
import { Box, Toolbar, Drawer, IconButton, Typography, Avatar } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { CloseRounded as IconCloseRounded } from '@mui/icons-material'
import { app } from '../../theme/themevars'
import ListUserNavigation from './ListUserNavigation'
import initials from 'initials'

const useStyles = makeStyles((theme) => ({
  avatar: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  drawer: {
    flexShrink: 0,
    overflowX: 'hidden',
    maxWidth: app.drawer.mobileMaxWidth,
  },
  drawerPaper: {
    borderLeft: 0,
    overflowX: 'inherit',
    maxWidth: 'inherit',
  },
  toolBar: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  iconButtonClose: {
    marginLeft: 'auto',
  },
}))

const UserNavigationMobile = ({ user, navigationItems }) => {
  const classes = useStyles()
  const [openUserNavigationMobile, handleOpenUserNavigationMobile] = useState(false)
  const toggleDrawerUserNavigation = () => handleOpenUserNavigationMobile(!openUserNavigationMobile)
  const { fullName, role, avatarUri } = user
  const userInitials = useMemo(() => initials(fullName), [fullName])

  return (
    <>
      <Box ml={1}>
        <IconButton
          aria-label={`${fullName} (${role})`}
          onClick={toggleDrawerUserNavigation}
          size="large"
          data-analytics="userNavigationMobileToggle"
        >
          <Avatar alt={fullName} src={avatarUri || null} className={classes.avatar}>
            {userInitials}
          </Avatar>
        </IconButton>
      </Box>
      <Drawer
        anchor="right"
        open={openUserNavigationMobile}
        onClose={toggleDrawerUserNavigation}
        className={classes.drawer}
        classes={{ paper: classes.drawerPaper }}
      >
        <Toolbar className={classes.toolBar} variant="dense" disableGutters>
          <Typography component="span" variant="h5">
            Gebruikersmenu
          </Typography>
          <IconButton
            color="primary"
            size="small"
            aria-label="Sluit het Gebruikersmenu"
            onClick={toggleDrawerUserNavigation}
            className={classes.iconButtonClose}
          >
            <IconCloseRounded />
          </IconButton>
        </Toolbar>
        <ListUserNavigation user={user} navigationItems={navigationItems} />
      </Drawer>
    </>
  )
}

UserNavigationMobile.propTypes = {
  user: PropTypes.shape({
    fullName: PropTypes.string.isRequired,
    role: PropTypes.string.isRequired,
    institute: PropTypes.string,
    avatarUri: PropTypes.string,
  }).isRequired,
  navigationItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      icon: PropTypes.node.isRequired,
      handleClick: PropTypes.func.isRequired,
      hideXsDown: PropTypes.bool,
    })
  ).isRequired,
}

export default UserNavigationMobile
